import React from 'react';
import { Link, useLocation } from 'react-router-dom';

function Navbar() {
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  return (
    <nav style={{
      backgroundColor: 'white',
      borderBottom: '1px solid var(--border)',
      padding: '1rem 0',
      marginBottom: '2rem'
    }}>
      <div className="container" style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
      }}>
        <Link to="/" style={{
          fontSize: '1.5rem',
          fontWeight: 'bold',
          color: 'var(--primary)',
          textDecoration: 'none'
        }}>
          🧬 Sidekick
        </Link>

        <div style={{ display: 'flex', gap: '1.5rem' }}>
          <Link
            to="/"
            className="link"
            style={{
              fontWeight: isActive('/') ? 600 : 400,
              color: isActive('/') ? 'var(--primary)' : 'var(--text)'
            }}
          >
            Home
          </Link>
          <Link
            to="/search"
            className="link"
            style={{
              fontWeight: isActive('/search') ? 600 : 400,
              color: isActive('/search') ? 'var(--primary)' : 'var(--text)'
            }}
          >
            Search
          </Link>
          <Link
            to="/sparql"
            className="link"
            style={{
              fontWeight: isActive('/sparql') ? 600 : 400,
              color: isActive('/sparql') ? 'var(--primary)' : 'var(--text)'
            }}
          >
            SPARQL
          </Link>
          <Link
            to="/explore"
            className="link"
            style={{
              fontWeight: isActive('/explore') ? 600 : 400,
              color: isActive('/explore') ? 'var(--primary)' : 'var(--text)'
            }}
          >
            Explore
          </Link>
          <Link
            to="/about"
            className="link"
            style={{
              fontWeight: isActive('/about') ? 600 : 400,
              color: isActive('/about') ? 'var(--primary)' : 'var(--text)'
            }}
          >
            About
          </Link>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
